import {
  ResponseTypeEnum,
  TemplateNodeSchema,
  TemplatePageSchema,
} from '@ulysses-inc/harami_api_client'
import { TemplateNodesDict } from 'src/exShared/types/types'

/**
 * 指定したノードの親(セクション・条件分岐・ページ)の直下にあるノード id のリストを返す。
 * 質問はセクションや条件分岐に属さず、ページ直下に置かれることもあるため、両方を親の候補として探す。
 *
 * 計算式・時間計測・ラベル検査のように「同じ親に属する質問のみ参照できる」設定は、
 * 参照先をこの兄弟の中から引くことで同一親の制約を満たす。
 *
 * @param nodeId 対象のノード id
 * @param templateNodes すべてのノード
 * @param templatePages すべてのページ
 * @returns 兄弟ノードの id (対象のノード自身を含む)。親が見つからない場合は undefined
 */
export const findSiblingNodeIds = (
  nodeId: number,
  templateNodes: TemplateNodeSchema[],
  templatePages: TemplatePageSchema[],
): number[] | undefined => {
  const parentPage = templatePages.find(page => page.nodes?.includes(nodeId))
  if (parentPage) {
    return parentPage.nodes ?? []
  }

  return templateNodes.find(node => node.nodes.includes(nodeId))?.nodes
}

/**
 * 兄弟ノードのうち、指定した回答種別の質問を uuid で引けるマップにする
 *
 * @param siblingNodeIds 兄弟ノードの id
 * @param templateNodesDict すべてのノードの辞書
 * @param responseType 対象の回答種別
 */
export const buildSiblingQuestionMapByUuid = (
  siblingNodeIds: number[],
  templateNodesDict: TemplateNodesDict,
  responseType: ResponseTypeEnum,
): Map<string, TemplateNodeSchema> => {
  return siblingNodeIds.reduce((acc, nodeId) => {
    const node = templateNodesDict[nodeId]
    if (node?.uuid && node.question?.responseType === responseType) {
      acc.set(node.uuid, node)
    }
    return acc
  }, new Map<string, TemplateNodeSchema>())
}
